export const beforeItems: string[] = [
  'Passi ore a cercare immagini e spunti sparsi online',
  'Non sai se la tecnica è adatta all’età della classe',
  'Improvvisi le lezioni all’ultimo minuto',
  'Ti senti insicuro/a quando devi disegnare qualcosa alla lavagna',
  'Nessuna verifica pronta da usare',
]

export const afterItems: string[] = [
  'Ogni lezione è già pronta, dalla pagina 1',
  'Percorso a spirale calibrato per età, dalla primaria alle medie',
  '64 unità già strutturate: introduzione, attività, scheda, verifica',
  'Guida passo-passo pensata anche per chi non è un artista',
  'Verifiche e griglie di valutazione incluse in ogni volume',
]

export const transformationStats: { value: string; label: string }[] = [
  { value: '8 Volumi', label: '+ 5 bonus, dalla primaria alla terza media' },
  { value: '64 Unità', label: 'Già strutturate: attività, scheda, verifica' },
  { value: '100%', label: 'Pronto da stampare, senza preparazione' },
]
